import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef, useState } from 'react';
import { Loader } from 'react-feather';
import defaultStyles from './styles/Switch.module.scss.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';
import { VisuallyHidden } from '../visuallyHidden/VisuallyHidden.js';

const Switch = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    disabled,
    isSmall = false,
    loading,
    onChange,
    type = 'circle',
    checkedText,
    uncheckedText,
    checkedIcon,
    uncheckedIcon,
    dataTestId,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [checked, setChecked] = useState(props.defaultChecked);
  const mergedChecked = 'checked' in props ? props.checked : checked;
  const onHandleClick = event => {
    if (loading) {
      return;
    }
    if (!('checked' in props)) {
      setChecked(!mergedChecked);
    }
    onChange && onChange(!mergedChecked, event);
  };
  const switchTypeClasses = clsx({
    [styles.circle]: type === 'circle',
    [styles.square]: type === 'square',
    [styles.line]: type === 'line'
  });
  const swicthClassNames = clsx(styles.switch, {
    [styles.small]: isSmall,
    [styles.checked]: mergedChecked,
    [styles.loading]: loading
  }, switchTypeClasses);
  const checkedElement = checkedText;
  const unCheckedElement = uncheckedText;
  const extraProps = omit(rest, ['onChange', 'checked', 'error']);
  return /*#__PURE__*/jsxs("button", {
    ref: ref,
    ...extraProps,
    className: swicthClassNames,
    disabled: disabled,
    onClick: onHandleClick,
    type: "button",
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: "Switch button"
    }), /*#__PURE__*/jsxs("div", {
      className: styles.dot,
      children: [!loading && (checkedIcon || uncheckedIcon) && /*#__PURE__*/jsx("span", {
        className: styles.dot_icon,
        children: mergedChecked ? checkedIcon : uncheckedIcon
      }), loading && /*#__PURE__*/jsx("span", {
        className: styles.dot_icon,
        children: /*#__PURE__*/jsx(Loader, {})
      })]
    }), !isSmall && type !== 'line' && (checkedElement || unCheckedElement) && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("div", {
        className: styles.text_holder,
        children: [checkedElement && mergedChecked && checkedElement, unCheckedElement && !mergedChecked && unCheckedElement]
      }), /*#__PURE__*/jsxs("div", {
        className: styles.text,
        children: [checkedElement && mergedChecked && checkedElement, unCheckedElement && !mergedChecked && unCheckedElement]
      })]
    })]
  });
});
Switch.displayName = 'Switch';

export { Switch };
